import { render, staticRenderFns } from "./CategoryDetailsDedicated.vue?vue&type=template&id=69df0ace"
import script from "./CategoryDetailsDedicated.vue?vue&type=script&lang=js"
export * from "./CategoryDetailsDedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports